import { render, staticRenderFns } from "./nepaLanding.vue?vue&type=template&id=278476ad&scoped=true"
import script from "./nepaLanding.vue?vue&type=script&lang=js"
export * from "./nepaLanding.vue?vue&type=script&lang=js"
import style0 from "./nepaLanding.vue?vue&type=style&index=0&id=278476ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278476ad",
  null
  
)

export default component.exports